import styled from 'styled-components';

export default styled.div`
  font-size: 16px;
  font-weight: bold;
  text-transform: capitalize;
`;
